import React from "react";

const ColoredBadge = ({ colorClass = "bg-teal-500 text-white", text }) => {
    return (
        <span
            className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium ${colorClass}`}
        >
            {text}
        </span>
    );
};

export default ColoredBadge;
